import { cn } from '@/lib/cn';
import { CURATED_ICON_NAMES, resolveIcon } from './icons';

interface IconPickerProps {
  value: string;
  onChange: (name: string) => void;
  /** Cor de destaque do ícone selecionado (default roxo). */
  accentColor?: string;
  className?: string;
}

/** Grade de ícones do set curado. O selecionado ganha anel roxo + fundo suave. */
export function IconPicker({ value, onChange, accentColor, className }: IconPickerProps) {
  return (
    <div
      className={cn('grid grid-cols-6 gap-2 sm:grid-cols-8', className)}
      role="radiogroup"
      aria-label="Ícone"
    >
      {CURATED_ICON_NAMES.map((name) => {
        const Icon = resolveIcon(name);
        const selected = name === value;
        return (
          <button
            key={name}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={name}
            onClick={() => onChange(name)}
            className={cn(
              'grid aspect-square place-items-center rounded-lg border transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
              selected
                ? 'border-primary bg-primary-weak text-primary'
                : 'border-border text-muted hover:bg-canvas hover:text-ink',
            )}
            style={selected && accentColor ? { color: accentColor, borderColor: accentColor } : undefined}
          >
            <Icon className="size-5" />
          </button>
        );
      })}
    </div>
  );
}
